import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import React from 'react'
import { Currency } from '../../../../api/asset-holders/Currency'
import { type LedgerAccountDetails } from '../../../../api/schema-dtos/AssetHolderFinancePayloadDtos'
import { useAppSelector } from '../../../../app/hooks'
import { selectAuthUserSettlementsEnabled } from '../../../auth/authSlice'
import { type AssetHolderIdProps } from '../../pages/DashboardHome'

interface WalletsComponentProps extends AssetHolderIdProps {
  wallets: LedgerAccountDetails[]
}

const WalletsComponent: React.FC<WalletsComponentProps> = ({ assetHolderId, wallets }: WalletsComponentProps) => {
  const userSettlementsEnabled = useAppSelector(selectAuthUserSettlementsEnabled)

  return (
    <>
      <Grid container spacing={2}>
        {wallets.map((wallet: LedgerAccountDetails, index: number) => (
          <Grid item md={6} xs={12} key={index} >
            <Card sx={{ minWidth: 250 }} variant={'outlined'}>
              <CardHeader title={wallet.accountName} sx={{ pb: 1 }}> </CardHeader>

              <CardContent sx={{ pt: 0 }}>
                <Typography variant={'h4'} color={'primary'}
                            sx={{ textAlign: 'center', mb: 2 }}>{wallet.currencyDisplayCode} {wallet.availableBalanceFormatted}</Typography>

                <Grid container columnSpacing={2}>
                  <Grid item md={12} xs={12}>
                    { wallet.pendingWithdrawalsBalance > 0 && (
                    <Box display={'flex'} justifyContent={'space-between'} >
                      <Typography variant={'caption'}>Pending&nbsp;withdrawals</Typography>
                      <Typography variant={'caption'}>{wallet.currencyDisplayCode}&nbsp;{wallet.pendingWithdrawalsBalanceFormatted}</Typography>
                    </Box>
                    )}
                  </Grid>

                  { userSettlementsEnabled && wallet.currencyCode === Currency.ZAR && wallet.pendingConversionsBalance > 0 && (
                    <Grid item md={12} xs={12}>
                      <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant={'caption'}>Pending&nbsp;conversions</Typography>
                        <Typography variant={'caption'}>{wallet.currencyDisplayCode}&nbsp;{wallet.pendingConversionsBalanceFormatted}</Typography>
                      </Box>
                    </Grid>
                  )}

                </Grid>

              </CardContent>
            </Card>

          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default WalletsComponent
